import { render, staticRenderFns } from "./BannerContentWrapper.vue?vue&type=template&id=66cec532&"
import script from "./BannerContentWrapper.vue?vue&type=script&lang=js&"
export * from "./BannerContentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports